/**
 * TestDataToggle — header switch for the global test/real data mode.
 * Exclusive: ON = viewing test data only, OFF = viewing real data only.
 * Visible to council and admin roles only (based on REAL user, not impersonated).
 */

import { makeStyles, tokens, Switch, Text } from '@fluentui/react-components'
import { useTestDataVisibility } from '../context/TestDataVisibilityContext'
import { useAuth } from '../context/AuthContext'

const useStyles = makeStyles({
  wrap: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalXS,
  },
  label: { fontSize: '12px', color: '#424242', whiteSpace: 'nowrap' },
  mode: { fontSize: '11px', fontWeight: 600, whiteSpace: 'nowrap' },
  modeTest: { color: '#d83b01' },
  modeReal: { color: '#107c10' },
})

export function TestDataToggle() {
  const styles = useStyles()
  const { showTestData, setShowTestData } = useTestDataVisibility()
  const { user } = useAuth()
  const role = user?.role
  const isCouncilOrAdmin = role === 'council' || role === 'admin' || role === 'super_admin'

  if (!isCouncilOrAdmin) return null

  return (
    <label className={styles.wrap}>
      {/* The label names the state, not the action. It used to name the action
          ("Show real data") while the colour named the state, so a switch that
          was ON sat next to the words "real data" in test-data orange — and,
          since filtering is exclusive and prod's [TEST] rows are purged, next
          to an empty board. It read as "your real data is gone". */}
      <Text className={`${styles.mode} ${showTestData ? styles.modeTest : styles.modeReal}`}>
        {showTestData ? 'Test data' : 'Real data'}
      </Text>
      <Switch
        checked={showTestData}
        onChange={(_, d) => setShowTestData(d.checked)}
        aria-label={showTestData ? 'Viewing test data — switch off for real data' : 'Viewing real data — switch on for test data'}
      />
    </label>
  )
}
